import { render } from "./DatosNumericos.vue?vue&type=template&id=a4c549e2&scoped=true"
import script from "./DatosNumericos.vue?vue&type=script&lang=js"
export * from "./DatosNumericos.vue?vue&type=script&lang=js"

import "./DatosNumericos.vue?vue&type=style&index=0&id=a4c549e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c549e2"]])

export default __exports__